import { fetchUtils, GET_LIST, GET_MANY, GET_ONE } from "react-admin";
import { stringify } from "query-string";

const initProjectTeamsProvider = (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  defaultCrudHandler,
  convertDataRequestToHTTP
) => {
  return (type, resource, params) => {
    switch (type) {
      case GET_LIST: {
        let url = "";
        const options = {};
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

        const sortStr = params.hasOwnProperty("sort")
          ? `&sort=${field},${order}`
          : "";

        url = `${apiUrl}/${resource}?page=${
          page - 1
        }&size=${perPage}${sortStr}&${stringify(params.filter)}`;
        return { url, options };
      }
      case GET_MANY:
        return httpClient(`${apiUrl}/projects/${params.ids}/teams`).then(
          (response) => ({
            data: response.json.content,
            total: parseInt(response.json.totalElements, 10),
          })
        );
      case GET_ONE:
        return httpClient(`${apiUrl}/teams?ids=${params.id}`).then(
          (response) => ({
            data: response.json.content,
            total: parseInt(response.json.totalElements, 10),
          })
        );
      default:
        return defaultCrudHandler(type, resource, params);
    }
  };
};

export default initProjectTeamsProvider;
